import additionWithin10 from "./Generator/additionWithin10";
const mathProblemsByDatabaseId = {
  m1: {
    description: { "en-US": "Addition Within 10", "zh-CN": "10以内加法"},
    generateProblems: additionWithin10,
    grade: "1"
  }
}

export default mathProblemsByDatabaseId;